import moment from 'moment';
const formats = {
  default: 'D.M.YYYY',
  api: 'YYYY-MM-DD',
  table: 'DD.MM.YYYY'
};
class DateFormatter {
  format(value) {
    if (!value) {
      return '';
    }
    return moment(value, formats.api).format(formats.default);
  }
  formatForApi(value) {
    return moment(value, formats.default).format(formats.api);
  }
  formatForTable(value) {
    if (!value) {
      return '';
    }
    return moment(value, formats.api).format(formats.table);
  }
}
const dateFormatter = new DateFormatter();
export default dateFormatter;